import clsx from 'clsx';
import { useTtDetails } from '../../TtDetails';
import { Investment, TtDetails } from '../../generated/graphql';
import { InvestmentSumTableItem } from './InvestmentSumTableItem';
import { InvestmentsTableContainer, InvestmentsTableContainerProps } from './InvestmentsTableContainer';
interface PersonalFinancialStatementInvestmentsTableProps
  extends Pick<InvestmentsTableContainerProps, 'tableTitleClassName'> {
  householdID: string;
  onItemClicked?: (a: { investment: Investment }) => void;
  investmentsSubset: keyof Pick<TtDetails['assetSummary'], 'afterTaxInvestments' | 'preTaxInvestments'>;
}

export function PersonalFinancialStatementInvestmentsTable({
  householdID,
  onItemClicked,
  investmentsSubset,
  tableTitleClassName,
}: PersonalFinancialStatementInvestmentsTableProps) {
  const { ttDetails, ttDetailsQuery } = useTtDetails({ householdID, includeAssetSummary: true });

  return (
    <InvestmentsTableContainer
      investmentArray={Array.from(ttDetails?.assetSummary[investmentsSubset] || [])}
      isLoading={ttDetailsQuery.isLoading}
      className="mb-4 md:mb-[47px] last:mb-6"
      tableRowsContainerClassName="mt-[2px]"
      tableTitleClassName={clsx(tableTitleClassName, 'sticky top-[56px] z-[1] bg-darkMode-gray-background')}
      investmentsSubset={investmentsSubset}
      onItemClicked={onItemClicked}
    >
      {({ investment }) => (
        <InvestmentSumTableItem
          key={investment.id}
          investment={investment}
          onItemClicked={onItemClicked}
          className="focus:shadow-classic"
        />
      )}
    </InvestmentsTableContainer>
  );
}
